// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6a117678","239":"50d454db","455":"24a28075"}[chunkId] + ".chunk.js";
};